import React, {useEffect, useState, useRef} from 'react';
import './CategoryNavigation.less';
import 'intersection-observer';
import {ChipList} from 'elements/chip-list/ChipList';
import {Chip} from "../../elements/chip/Chip";
import Platform from '../../../platform';
import platform from "../../../platform";

export const CategoryNavigation = ({categories = [], selectedCategory, onCategoryClick}) => {
	const selectedCategoryRef = useRef(null);
	const categoriesContainerRef = useRef(null);

	useEffect(() => {
		if (selectedCategory.click) {
			return;
		}

		if (!selectedCategoryRef.current || !categoriesContainerRef.current) {
			return;
		}
		if (categories[0].id === selectedCategory.id) {
			categoriesContainerRef.current.scrollLeft = 0;
			return;
		}
		if (platform.isFirefox) {
			selectedCategoryRef.current.scrollIntoView({
				block: "nearest"
			});
			return;
		}
		selectedCategoryRef.current.scrollIntoViewIfNeeded
			? selectedCategoryRef.current.scrollIntoViewIfNeeded()
			: selectedCategoryRef.current.scrollIntoView();
	}, [selectedCategory]);

	return (
		<div
			className={`category-navigation ${(!Platform.isAndroid || !Platform.isIOs) ? 'category-navigation--scroll' : ''}`}
			ref={categoriesContainerRef}
		>
			{ categories.length > 1 &&
			<div className="category-navigation__container">
				<ChipList>
					{categories.map((category, index) => {
						const isSelected = category.id === selectedCategory.id;
						return (
							<div
								key={'nav-cat-' + category.id}
								id={'nav-cat-' + category.id}
								ref={isSelected ? selectedCategoryRef : null}
							>
								<Chip
									isOutlined={true}
									key={category.id}
									text={category.name}
									isSelected={isSelected}
									onClick={isSelected ? null : () => onCategoryClick(category.id)}
								/>
							</div>
						);
					})}
				</ChipList>
			</div> }
		</div>
	);
};
